export const EXISTE_ASG = {
  SI: "si",
};
